import InfoIcon from '@mui/icons-material/Info';
import MuiTooltip from '@mui/material/Tooltip';
import './Tooltip.css';
import IconButton from '@mui/material/IconButton';

const Tooltip = ({ children, title, placement = 'top' }) => {
  const contentIsPrimitive = typeof children === 'string' || typeof children === 'number';

  return (
    <MuiTooltip
      title={title ?? ''}
      placement={placement}
      arrow={true}
      slotProps={{
        tooltip: {
          sx: (theme) => ({
            fontSize: theme.typography.htmlFontSize,
            backgroundColor: theme.palette.grey[700],
            '& .MuiTooltip-arrow': {
              color: theme.palette.grey[700],
            },
          }),
        },
      }}
    >
      {contentIsPrimitive ? (
        <span className="tooltip-component-primitive-wrapper" tabIndex="0">
          {children}
        </span>
      ) : (
        (children ?? (
          <IconButton sx={{ width: 'fit-content' }}>
            <InfoIcon />
          </IconButton>
        ))
      )}
    </MuiTooltip>
  );
};

export default Tooltip;
